export const NON_CHARACTER_KEYS = [
  'Backspace',
  'Delete',
  'Tab',
  'Escape',
  'Enter',
  'ArrowLeft',
  'ArrowRight',
  'ArrowUp',
  'ArrowDown',
  'Home',
  'End',
];

export const VALID_ZIP_TYPE = 'STANDARD';
export const ZIP_TYPE_KEY = 'zipType';
